import axios from "axios";

export default axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api/v1`,
  headers: {
    "Content-type": "application/json",
	"x-ref": "YjJjZmVlZTctZjc3Ny00ODU1LTllMTctYjBjZDYzNzQ0OGNl",
  }
});

/*
*** baseURL: `${process.env.REACT_APP_BASE_URL}/api/v1`,
*/